'use client';
import { useQuery } from '@tanstack/react-query';
import { getMinuteBanner } from '@pulsex/services';
export default function useMinuteBanner(config) {
    const query = useQuery({
        queryKey: ['GET_MINUTE_BANNER'],
        queryFn: () => getMinuteBanner(config),
        refetchOnWindowFocus: false,
    });
    if (query.isError) {
        console.error('Query Error:', query.error);
    }
    return {
        isLoading: query.isLoading,
        data: query.data,
    };
}
